import React from 'react';
import { FadeIn } from './FadeIn';
export function ProblemSolution() {
  return <section className="py-20 md:py-28 bg-white overflow-hidden" data-id="element-735">
      <div className="max-w-[900px] mx-auto px-6 md:px-8" data-id="element-736">
        <FadeIn data-id="element-737">
          <div className="bg-ivory border border-gold/40 rounded-[32px] p-8 md:p-12 lg:p-16 shadow-xl relative overflow-hidden" data-id="element-738">
            {/* Decorative background in the card */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-forest/5 rounded-full blur-3xl -z-10" data-id="element-739"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-gold/10 rounded-full blur-2xl -z-10" data-id="element-740"></div>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium text-forest mb-10 text-center leading-tight" data-id="element-741">
              Ai construit o viață care funcționează, dar nu te mai reprezintă?
            </h2>

            <div className="space-y-6 text-charcoal/80 font-sans text-[19px] leading-relaxed" data-id="element-742">
              <p data-id="element-743">
                Muncești mult. Ai grijă de toți. Livrezi la serviciu, ești acolo
                pentru familie, faci tot ce trebuie. Și totuși, undeva în
                interior, simți că ceva nu mai e în regulă. Te trezești
                dimineața obosită înainte să înceapă ziua. Stresul nu se mai
                oprește. Te întrebi:{' '}
                <span className="font-serif italic text-forest text-xl" data-id="element-744">
                  „Și eu acum ce fac?”
                </span>
              </p>

              <p data-id="element-745">
                Dacă rămâi acolo, oboseala se transformă în burnout. Burnout-ul
                se transformă în depresie. Pierzi anii pe care îi pui deoparte
                pentru „mai târziu”. Relațiile se răcesc. Visurile devin
                amintiri. Iar senzația că ești o străină în propria viață devine
                starea ta normală.
              </p>

              <div className="mt-10 pt-8 border-t border-gold/30" data-id="element-746">
                <p className="font-medium text-forest" data-id="element-747">
                  ANIMA Recode este un proces ghidat de transformare pe 9 luni,
                  construit pentru femei care nu mai vor doar să funcționeze.
                </p>
                <p className="mt-4" data-id="element-748">
                  Lucrăm simultan pe minte, emoții și sistemul din care vii, ca
                  schimbarea să fie reală, nu doar înțeleasă. Nu îți dau
                  răspunsuri rapide. Te ghidez printr-un proces care te duce
                  înapoi la tine.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}